import { render } from "./Loading.vue?vue&type=template&id=014bbdc2"
const script = {}

import exportComponent from "C:\\Users\\toru-ota\\source\\repos\\Marron\\Jarvis\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__